import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import CancelButton from '../../../general/inputs/CancelButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import InfoRow from '../../../general/inputs/InfoRow';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { updateGroupSeats } from '../../../../routes/doctor/billing';
import { setIsRefreshSubscription } from '../../../../redux/features/doctor/billing/billing';
import { setIsLoadingPopupOpened, setIsUpdateSeatsPopupOpened } from '../../../../redux/features/general/navigation';
import DataBox from '../../../general/data/DataBox';
import { getGroupMemberInfo } from '../../../../routes/doctor/account';
import MemberRow from './MemberRow';
import TollIcon from '@mui/icons-material/Toll';
import { seatsList } from '../../../hacker/groups/info/GroupSettingsOptions';
import TuneIcon from '@mui/icons-material/Tune';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Popup from '../../../general/popups/items/Popup';

interface Props { 

}; 

const UpdateSeatsPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const groupAccessList = useAppSelector(state => state.groupAccess.groupAccessList);  
    const group = useAppSelector(state => state.billing.group); 

    const [seats, setSeats] = useState(0); 
    
    // -- 

    const handler = async (newLanguage: string) => {

    };

    // -- 

    const emptyFunction = () => { 

        return; 

    }

    // -- 

    const handleQuit = () => { 

        dispatch(setIsUpdateSeatsPopupOpened(false)); 

    }; 

    // -- 

    const handleSeatsUpdate = async (item: any) => { 

      if (item) { 

        setSeats(item.seats); 

      }; 

    }; 

    // --

    // -- 

    const handleSubscriptionUpdate = async () => { 

        if (seats) { 

            dispatch(setIsLoadingPopupOpened(true)); 

            const res = await updateGroupSeats(seats); 

            dispatch(setIsLoadingPopupOpened(false)); 

            if (res?.data.status == 200) { 

                dispatch(setNotificationMessage(t('seatsUpdated'))); 

                dispatch(setIsRefreshSubscription(true)); 

                dispatch(setIsUpdateSeatsPopupOpened(false)); 

            }; 

        }; 

    }; 

    // --

    useEffect(() => { 

        if (group) { 

            setSeats(group.seats + 1); 

        }; 

    },[group]); 
    
    // -- 

    return (

        <Popup>

            { groupAccessList?.length >= 1 && 
                <Box sx={{ 
                    overflow: 'auto',
                    width: '100%',
                    height: '30vh', 
                    marginTop: 4 }}>
            
                    <List dense>
            
                    {groupAccessList?.map((item, index) => { 

            
                        return <ListItem sx={{ color: colors?.text }} button key={index}>

                                {(item.status == 'active') && <MemberRow item={item} />}
        
                        </ListItem>

                    })}
            
                    </List>
            
                </Box>}

            <DataBox
                extraStyle={{ backgroundColor: 'rgb(250, 250, 250)'}}
            >

                <InfoRow 
                    title='currentSeats'
                    description={group?.seats}
                    descriptionStyle={{ fontWeight: 'bold' }}
                    isDisabled
                />

                <InfoRow 
                    title='updateTo'
                    icon={<TollIcon sx={{ color: colors?.main }} />}
                    description={seats}
                    listHandler={handleSeatsUpdate}
                    listIcon={
                        <KeyboardArrowDownIcon 
                            sx={{ 
                                color: 'white', 
                                fontSize: 18, 
                                '&:hover': { color: 'white' } }} 
                        />
                    }
                    listIconStyle={{ 
                        backgroundColor: 'rgb(92, 160, 223)',
                        '&:hover': { backgroundColor: colors?.mainHover }
                    }}
                    dataList={seatsList}
                    rowIcon={<TollIcon sx={{ color: 'purple' }} />}
                    rowDescription={'seats'}
                    extraStyle={{ '&:hover': { backgroundColor: 'transparent' }}}
                />

                <InfoRow 
                    title='confirmUpdate'
                    description={
                        <Button 
                            title='confirm'
                            triggerFunction={handleSubscriptionUpdate}
                            isDisabled={(seats == group?.seats) ? true : false}
                        />
                    }
                    isDisabled
                />

            </DataBox>

            <Box
                sx={{ 
                    width: '95%',
                    flexDirection: 'column', 
                    alignItems:'center',
                    justifyContent: 'space-evenly',
                    fontSize: 12, 
                    color: 'rgb(150, 150, 150)',
                    marginTop: 1,
                    marginBottom: 1, 
                }}
            >{t('udpateSubscriptionWarning')}
            </Box>

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Popup>

  );

};

export default UpdateSeatsPopup;